module.exports = __webpack_public_path__ + "static/controleur-wifi-be1a665b75c03b126065cfe402615a63.mp4";